// extracted by mini-css-extract-plugin
var _1 = "FormFields-moduleactions__AHR_j FormActions-moduleFormActions__WNNEs";
var _2 = "FormFields-modulelabel__FXroW";
var _3 = "FormFields-modulemessage__zQhey";
export { _1 as "actions", _2 as "label", _3 as "message" }
